var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoGauche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43,62.54c-.77,0-1.54-.29-2.12-.88l-24.91-24.91c-1.27-1.27-1.97-2.95-1.97-4.75s.7-3.48,1.97-4.75L40.88,2.34c1.17-1.17,3.07-1.17,4.24,0,1.17,1.17,1.17,3.07,0,4.24l-24.91,24.91c-.17.17-.21.37-.21.51s.04.33.21.51l24.91,24.91c1.17,1.17,1.17,3.07,0,4.24-.59.59-1.35.88-2.12.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoGauche);
export default __webpack_public_path__ + "static/media/picto-gauche.9cd6ffcffabcb9c23031a863a906635d.svg";
export { ForwardRef as ReactComponent };